import { Record, Map } from "immutable"

const WorkspaceHistory = Record({
  id: 0,
  workspace: Map(),
  previous_history: Map()
})

export default WorkspaceHistory
